import { Icon } from "@/components";
import {
  PATH,
  ENV,
  USER_VIEW,
  SUBSCRIPTION_PRODUCT_TYPE,
} from "@/configuration/globalVariable";
import { Nav } from "@/models";

// Screen
// import GetStartedScreen from "@/pages/GetStarted";
import DashboardScreen from "@/pages/Dashboard";
import EnterOrderScreen from "@/pages/EnterOrder";
import SalesOrdersScreen from "@/pages/SalesOrders";
import OrdersScreen from "@/pages/SalesOrders/Screens/Orders";
import ImportOrderScreen from "@/pages/SalesOrders/Screens/ImportOrder";

import CustomerManagementScreen from "@/pages/CustomerManagement";
import MyCustomerScreen from "@/pages/CustomerManagement/Screens/MyCustomer";
import MyCustomerEditScreen from "@/pages/CustomerManagement/Screens/MyCustomerEdit";
import BrowseCustomerScreen from "@/pages/CustomerManagement/Screens/BrowseCustomer";

import DeliveryScreen from "@/pages/Delivery";
import DeliveryManifestsScreen from "@/pages/Delivery/Screens/DeliveryManifests";
import EditRoutesScreen from "@/pages/Delivery/Screens/EditRoutes";
import DeliveryRouteDetailScreen from "@/pages/Delivery/Screens/DeliveryRouteDetail";
import DeliveryRouteOptimizingScreen from "@/pages/Delivery/Screens/Optimizing";
import DeliveryRouteOptimizeGroupPreviewScreen from "@/pages/Delivery/Screens/OptimizedGroupPreview";

import SchedulePlanner from "@/pages/SchedulePlanner";
import DeliveryScheduleDetailScreen from "@/pages/SchedulePlanner/Screens/DeliveryScheduleDetail";
import DeliveryScheduleEditScreen from "@/pages/SchedulePlanner/Screens/DeliveryScheduleEdit";
import SchedulePlannerList from "@/pages/SchedulePlanner/Screens/SchedulePlanner";
import SchedulePlannerAssignedList from "@/pages/SchedulePlanner/Screens/SchedulePlannerAssignedList";

import CommonAppComponentWrap from "@/pages/CommonAppComponent";
import ButtonScreen from "@/pages/CommonAppComponent/Screens/Buttons";
import IconScreen from "@/pages/CommonAppComponent/Screens/Icons";
import FromScreen from "@/pages/CommonAppComponent/Screens/Form";
import TooltipScreen from "@/pages/CommonAppComponent/Screens/Tooltip";
import LabelScreen from "@/pages/CommonAppComponent/Screens/Label";
import NotistackScreen from "@/pages/CommonAppComponent/Screens/Notistack";
import AlertScreen from "@/pages/CommonAppComponent/Screens/Alerts";
import ListBoxScreen from "@/pages/CommonAppComponent/Screens/ListBox";
import Timeline from "@/pages/CommonAppComponent/Screens/Timeline";
import Table from "@/pages/CommonAppComponent/Screens/Table";

import PantryList from "@/pages/PantryList";
import ExclusiveListsScreen from "@/pages/ExclusiveLists";
import ExclusiveListDetailScreen from "@/pages/ExclusiveLists/ExclusiveListDetail";
import AssignCustomersScreen from "@/pages/ExclusiveLists/AssignCustomers";
import CustomerExclusiveListScreen from "@/pages/CustomerExclusiveList";

export const sidebarNavigation: Nav[] = [
  {
    name: "Get Started",
    icon: Icon.Started,
    isDiffDomain: true,
    path: `/global/account/gettingstarted`,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Dashboard",
    icon: Icon.Dashboard,
    path: "/",
    element: DashboardScreen,
    index: true,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Enter Order",
    icon: Icon.Cart,
    isDiffDomain: true,
    path: `/sales/placeorder/documents/placeorder`,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Data Entry",
    icon: Icon.Cart,
    path: PATH.ENTER_ORDER,
    element: EnterOrderScreen,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Place Order",
    icon: Icon.Cart,
    isDiffDomain: true,
    path: `/purchases/placeorder/documents/placeorder`,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Sales Orders",
    icon: Icon.Bill,
    path: PATH.SALES_ORDERS._,
    element: SalesOrdersScreen,
    noPage: true,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "Orders",
        path: PATH.SALES_ORDERS.ORDERS,
        element: OrdersScreen,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Invoices",
        isDiffDomain: true,
        path: `/${PATH.SALES_ORDERS._}/${PATH.SALES_ORDERS.INVOICES}`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Quotes",
        isDiffDomain: true,
        path: `/${PATH.SALES_ORDERS._}/${PATH.SALES_ORDERS.QUOTES}`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Import",
        path: PATH.SALES_ORDERS.IMPORT,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
        element: ImportOrderScreen,
      },
    ],
  },
  {
    name: "Purchase Orders",
    icon: Icon.Bill,
    path: `purchases`,
    element: SalesOrdersScreen,
    noPage: true,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "Orders",
        isDiffDomain: true,
        path: `/purchases/documents/orders`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Invoices",
        isDiffDomain: true,
        path: `/purchases/documents/invoices`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Quotes",
        isDiffDomain: true,
        path: `/purchases/documents/quotes`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
    ],
  },
  {
    name: "Customer management",
    icon: Icon.Team,
    path: `relationship`,
    element: SalesOrdersScreen,
    noPage: true,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "Add customers",
        isDiffDomain: true,
        path: `/relationship/accounts/createcustomer`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "My customers",
        isDiffDomain: true,
        path: `/relationship/accounts/mycustomers`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Browse customers",
        isDiffDomain: true,
        path: `/relationship/accounts/browseCustomers`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
    ],
  },
  {
    name: "Supplier management",
    icon: Icon.Vehical,
    path: `relationship`,
    element: SalesOrdersScreen,
    noPage: true,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "Add suppliers",
        isDiffDomain: true,
        path: `/relationship/accounts/createsupplier`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "My suppliers",
        isDiffDomain: true,
        path: `/relationship/accounts/mysuppliers`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Browse suppliers",
        isDiffDomain: true,
        path: `/relationship/accounts/browseSuppliers`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
    ],
  },
  // New UI
  {
    name: "Customer Management*",
    icon: Icon.Team,
    path: PATH.CUSTOMER_MANAGEMENT,
    element: CustomerManagementScreen,
    noPage: true,
    isNavRender: true,
    envDisplay: [ENV.DEV],
    userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "My customers",
        index: true,
        path: PATH.MY_CUSTOMER,
        element: MyCustomerScreen,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "My customers editing",
        index: true,
        path: PATH.EDIT_MY_CUSTOMER + "/:id",
        element: MyCustomerEditScreen,
        isNavRender: false,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Browse customers",
        path: PATH.BROWSE_CUSTOMER,
        element: BrowseCustomerScreen,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
    ],
  },
  // {
  //   name: "Customer Management",
  //   icon: Icon.Team,
  //   isDiffDomain: true,
  //   path: OUTSITE_LINK,
  //   isNavRender: true,
  // },

  // Delivery group
  // {
  //   name: "Delivery",
  //   icon: Icon.Vehical,
  //   path: PATH.DELIVERY,
  //   element: DeliveryScreen,
  //   isNavRender: true,
  //   userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
  //   envDisplay: [ENV.DEV],
  // },
  // {
  //   name: "Delivery edit routes",
  //   path: `${PATH.DELIVERY}/${PATH.EDIT_ROUTES}`,
  //   element: EditRoutesScreen,
  //   userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
  //   envDisplay: [ENV.DEV],
  // },
  // {
  //   name: "Delivery route detail",
  //   path: `${PATH.DELIVERY}/${PATH.ROUTE_DETAILS}`,
  //   element: DeliveryRouteDetailScreen,
  //   userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
  //   envDisplay: [ENV.DEV],
  // },
  // {
  //   name: "Delivery allocate",
  //   path: `${PATH.DELIVERY}/${PATH.ALLOCATE}`,
  //   element: AllocateScreen,
  //   userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
  //   envDisplay: [ENV.DEV],
  // },
  // End Delivery group
  {
    name: "Scheduling",
    icon: Icon.Calendar,
    path: PATH.SCHEDULE_PLANNER._,
    element: SchedulePlanner,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    settingDisplay: "isSupportDeliverySchedule",
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "Schedule Planner list",
        index: true,
        element: SchedulePlannerList,
        path: PATH.SCHEDULE_PLANNER.SCHEDULE_LIST,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Schedule Planner detail",
        element: DeliveryScheduleDetailScreen,
        path: PATH.SCHEDULE_PLANNER.SCHEDULE_DETAIL,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Schedule Planner edit",
        element: DeliveryScheduleEditScreen,
        path: PATH.SCHEDULE_PLANNER.SCHEDULE_EDIT,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Schedule Planner assigned list",
        element: SchedulePlannerAssignedList,
        path: PATH.SCHEDULE_PLANNER.SCHEDULE_ASSIGNED_LIST,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
    ],
  },
  {
    name: "Delivery",
    icon: Icon.Vehical,
    path: PATH.DELIVERY._,
    element: DeliveryScreen,
    noPage: true,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [
      SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
      SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
    ],
    subItems: [
      {
        name: "Routes",
        isDiffDomain: true,
        path: `/delivery/routes`,
        isNavRender: true,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },
      {
        name: "Route allocation",
        isDiffDomain: true,
        path: `/delivery/routeallocation`,
        isNavRender: true,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },
      // {
      //   name: "Buttons",
      //   path: PATH.COMMON_BUTTON,
      //   element: ButtonScreen,
      //   index: true,
      //   isNavRender: true,
      // },

      // Feature is developing=================
      // {
      //   name: "Delivery allocation (dev)",
      //   path: `${PATH.ALLOCATE}`,
      //   element: AllocateScreen,
      //   isNavRender: true,
      //   envDisplay: [ENV.DEV],
      // },
      {
        name: "Delivery manifest",
        path: PATH.DELIVERY.DELIVERY_MANIFESTS,
        element: DeliveryManifestsScreen,
        isNavRender: true,
        isNew: true,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },
      {
        name: "Delivery route detail",
        path: `${PATH.DELIVERY.DELIVERY_MANIFESTS}/:routeDetailId`,
        element: DeliveryRouteDetailScreen,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },
      {
        name: "Delivery edit routes",
        path: `${PATH.DELIVERY.EDIT_ROUTES}`,
        element: EditRoutesScreen,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },

      // Optimize routes
      {
        name: "Delivery routes optimizing",
        path: `${PATH.DELIVERY.OPTIMIZING}`,
        element: DeliveryRouteOptimizingScreen,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },
      {
        name: "Delivery routes optimized preview",
        path: `${PATH.DELIVERY.OPTIMIZED_PREVIEW}`,
        element: DeliveryRouteOptimizeGroupPreviewScreen,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },
      {
        name: "Import",
        path: `${PATH.DELIVERY.IMPORT}`,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
        element: ImportOrderScreen,
      },
      // End optimize routes
      // End Feature is developing=============

      {
        name: "Driver setting",
        isDiffDomain: true,
        path: `/delivery/drivers`,
        isNavRender: true,
        subscriptions: [
          SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
          SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
        ],
      },
    ],
  },
  {
    name: "Price List",
    icon: Icon.Price,
    isDiffDomain: true,
    path: `/pricing/pricelist`,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Reports",
    icon: Icon.Report,
    path: `Reports`,
    element: SalesOrdersScreen,
    noPage: true,
    isNavRender: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "Sales",
        isDiffDomain: true,
        path: `/Reports/GenerateReports/SalesReports`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Picking",
        isDiffDomain: true,
        path: `/Reports/GenerateReports/PickingReports`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
    ],
  },
  {
    name: "Payment",
    icon: Icon.Money,
    isDiffDomain: true,
    path: `/payment/zai/index`,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Pantry List",
    icon: Icon.List,
    path: PATH.PANTRY_LIST,
    element: PantryList,
    isNavRender: false,
    isBeta: true,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Customer Exclusive List",
    icon: Icon.List,
    path: PATH.CUSTOMER_EXCLUSIVE_LIST,
    element: CustomerExclusiveListScreen,
    isNavRender: false,
    userView: [USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Pantry List",
    icon: Icon.List,
    isDiffDomain: true,
    path: `/orderforms/forms/pantry`,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
  },
  {
    name: "Inventory",
    icon: Icon.Box,
    path: `inventory`,
    element: SalesOrdersScreen,
    noPage: true,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
    subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
    subItems: [
      {
        name: "Products",
        isDiffDomain: true,
        path: `/inventory/products`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Product upload",
        isDiffDomain: true,
        path: `/inventory/productupload`,
        isNavRender: true,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Exclusive lists",
        path: `exclusive-lists`,
        element: ExclusiveListsScreen,
        isNavRender: true,
        userView: [USER_VIEW.SUPPLIER],
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Exclusive list detail",
        path: `exclusive-lists/${PATH.EXCLUSIVE_LISTS.DETAIL}`,
        element: ExclusiveListDetailScreen,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
      {
        name: "Assign customers",
        path: `exclusive-lists/${PATH.EXCLUSIVE_LISTS.ASSIGN_CUSTOMERS}`,
        element: AssignCustomersScreen,
        subscriptions: [SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS],
      },
    ],
  },
  {
    name: "Apps & Integrations",
    icon: Icon.Dashboard,
    isDiffDomain: true,
    path: `/businessIntegration/apps/`,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
    subscriptions: [
      SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
      SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
    ],
  },
  {
    name: "Settings",
    icon: Icon.Settings,
    isDiffDomain: true,
    path: `/Settings/ManageSettings/Options`,
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
    subscriptions: [
      SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
      SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
    ],
  },
  {
    name: "Storybook (Dev)",
    icon: Icon.Despatch,
    path: `${PATH.APP_STORYBOOK}`,
    element: CommonAppComponentWrap,
    envDisplay: [ENV.DEV],
    isNavRender: true,
    userView: [USER_VIEW.CUSTOMER, USER_VIEW.SUPPLIER],
    subscriptions: [
      SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
      SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
    ],
    subItems: [
      {
        name: "Buttons",
        path: PATH.COMMON_BUTTON,
        element: ButtonScreen,
        index: true,
        isNavRender: true,
      },
      {
        name: "Icons",
        path: PATH.COMMON_ICON,
        element: IconScreen,
        isNavRender: true,
      },
      {
        name: "Form",
        path: PATH.COMMON_FORM,
        element: FromScreen,
        isNavRender: true,
      },
      {
        name: "Tooltip",
        path: PATH.COMMON_TOOLTIP,
        element: TooltipScreen,
        isNavRender: true,
      },
      {
        name: "Label",
        path: PATH.COMMON_LABEL,
        element: LabelScreen,
        isNavRender: true,
      },
      {
        name: "Notistack",
        path: PATH.NOTISTACK,
        element: NotistackScreen,
        isNavRender: true,
      },
      {
        name: "Alert",
        path: PATH.ALERTS,
        element: AlertScreen,
        isNavRender: true,
      },
      {
        name: "ListBox",
        path: PATH.LISTBOX,
        element: ListBoxScreen,
        isNavRender: true,
      },
      {
        name: "Timeline",
        path: PATH.TIMELINE,
        element: Timeline,
        isNavRender: true,
      },
      {
        name: "Table",
        path: PATH.TABLE,
        element: Table,
        isNavRender: true,
      },
    ],
  },
] as any;
